import React, { useEffect, useRef, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box,
    Modal,
    Button,
    FormControl,
    Select,
    InputLabel,
    MenuItem,
    TextField, Tooltip,
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions
} from '@material-ui/core';
import { UpdateMappingFields } from '../../api/api';
import { toast } from 'react-toastify';
import { Autocomplete } from '@material-ui/lab';
import { lightBlue } from '@material-ui/core/colors';
import './MappingFields.css';

const MappingFieldsOverLay = ({ isOpen, mappingFields, close, callBack, Config, subConfig, customer }) => {
    const [open, setOpen] = React.useState(isOpen);
    const handleClose = () => close(false);
    const [mappingRows, setMappingRows] = useState([]);
    const [fileFieldRows, setFileFieldRows] = useState([]);
    const [enableCounty, setEnableCounty] = useState(true);
    const [distributionId, setDistributionId] = useState(mappingFields.DistributionId);
    const [showLoader, setLoader] = useState(false);
    const staticData = {
        ConfiguredFields: ['Name', 'LastName', 'Gender', 'Address', 'Mobile', 'Address', 'Mobile'],
        FileFields: ['Name', 'LastName', 'Gender', 'Address', 'Mobile']
    };

    const descriptionElementRef = React.useRef();

    const save = () => {

        let mappingSet = {};
        mappingRows.map((item) => {
            mappingSet[item.Name] = item.MappedField;
        });
        let formData = new FormData();
        formData.append("mapping_set", JSON.stringify(mappingSet));
        formData.append("transaction_id", mappingFields.TransactionId);
        formData.append("distribution_id", distributionId);
        formData.append("customer", mappingFields.Customer);
        formData.append("config_type", Config);
        formData.append("sub_config_type", subConfig);
        setEnableCounty(true);
        UpdateMappingFields(formData, function (result) {

            if (result.status === "success") {
                close(false);
                if (callBack)
                    callBack();
                toast.info(`Mappings Saved Successfully.`, { position: toast.POSITION.TOP_CENTER, autoClose: 3000 });
            } else
                toast.error(result.message, { position: toast.POSITION.TOP_CENTER, autoClose: 5000 });
        });
    }

    useEffect(() => {
        if (mappingFields && mappingFields.ConfiguredFields && mappingFields.FileFields) {
            var result = mappingFields.ConfiguredFields?.map((item, index) => {
                return {
                    Id: index,
                    Name: item.field,
                    Type: item.type,
                    Required: item.is_required,
                    Parent: item.is_parent,
                    MappedField: mappingFields.MappingSet ? mappingFields.MappingSet[item?.field] : ''
                };
            });

            setMappingRows(result);

            let fileFieldsList = mappingFields.FileFields.map((item) => item.field);
            setFileFieldRows(fileFieldsList);
        }
    }, []);


    const handleChange = (event, val, row) => {
        var temp = [...mappingRows];

        temp.map((item) => {
            if (item.Id == row.Id) {
                item.MappedField = val || '';
            }
        });

        setMappingRows(temp);
    };

    const onFileChange = (event) => {
        let value = event.target.value;

        setDistributionId(value);
    }

    const handleEdit = () => {
        setEnableCounty(!enableCounty);
    }

    return (
        <div>
            <Dialog
                open={isOpen}
                // onClose={handleClose}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                animation="false"
            >
                <DialogTitle id="scroll-dialog-title">MappedFields:</DialogTitle>
                <TableRow key={0}>
                    <TableCell  >
                        <b>County Id: </b>
                    </TableCell>
                    <TableCell  >
                        <input name="distribution_id" disabled={enableCounty} type="text" onChange={onFileChange} value={distributionId} />
                    </TableCell>
                    <TableCell  >
                        <i className="fa fa-edit" style={{ fontSize: '20px', color: '#000000', cursor: "pointer" }} onClick={handleEdit}></i>
                    </TableCell>
                    <TableCell>
                        {mappingFields.IsApproved === 'yes' ? <span style={{ color: 'green', fontWeight: 'bold' }}>Approved</span> : <span style={{ color: 'red', fontWeight: 'bold' }}>Pending Approval</span>}
                    </TableCell>
                </TableRow>
                <DialogContent dividers='paper'>
                    <DialogContentText
                        id="scroll-dialog-description"
                        tabIndex={-1}
                        style={{ minWidth: '55vw' }}
                        ref={descriptionElementRef}
                    >
                        <TableContainer component={Paper}>
                            <Table aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <b>Configured Fields</b>
                                        </TableCell>
                                        <TableCell>
                                            <b>Configured Field Type</b>
                                        </TableCell>
                                        <TableCell>
                                            <b>File Fields</b>
                                        </TableCell>
                                        <TableCell>
                                            <b>File Field Type</b>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {mappingRows.map((row) => (
                                        <TableRow key={row.Id}>
                                            <TableCell style={{ padding: '5px 15px' }} component="td" scope="row">
                                                <span style={{ color: "red", fontSize: "18px", display: row.Required === 'yes' ? "" : 'none' }}> *</span>
                                                {row.Name}
                                                {row.Parent === 'yes' && (<React.Fragment><br /><small style={{ color: "blue" }}>(Parent)</small></React.Fragment>)}
                                            </TableCell>
                                            <TableCell style={{ padding: '5px 15px', textAlign: 'center' }} component="td" scope="row">
                                                {row.Type}
                                            </TableCell>
                                            <TableCell style={{ padding: '5px 15px' }}>
                                                <FormControl style={{ width: '220px', textAlign: 'left' }} size="small">
                                                    {/*<InputLabel id="demo-simple-select-label">Select Field</InputLabel>
                                                     <Select
                                                        labelId="demo-simple-select-label"
                                                        value={row.MappedField}
                                                        label="Select Field"
                                                        onChange={(e) => handleChange(e, row)}
                                                    >
                                                        {fileFieldRows.map((field) => (
                                                            <MenuItem value={field}>{field}</MenuItem>
                                                        ))}
                                                    </Select> */}
                                                    <Tooltip title={row.MappedField || ""} arrow>
                                                        <Autocomplete
                                                            disablePortal
                                                            options={fileFieldRows}
                                                            value={row.MappedField}
                                                            sx={{ width: 300 }}
                                                            onChange={(e, val) => handleChange(e, val, row)}
                                                            renderInput={(params) => <TextField {...params} label="Select Field"
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    style: { textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', width: '200px' }
                                                                }} />}
                                                        />
                                                    </Tooltip>
                                                </FormControl>
                                            </TableCell>
                                            <TableCell style={{ padding: '5px 15px', textAlign: 'center' }} component="td" scope="row">
                                                {
                                                    mappingFields.FileFields.find((item) => item.field === row.MappedField)?.type
                                                }
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContentText>
                </DialogContent>

                <div className='footerRow'>
                    <span className='editStyle'> * Required.</span>
                    <div className='btnGroup'>
                        <Button className='btnStyle' onClick={handleClose}>Close</Button>
                        <Button className='btnStyle' onClick={save}>Save</Button>
                    </div>
                </div>

                {/* <DialogActions>
                    <span className='editStyle'> * Required.</span>
                    <Button className='btnStyle' onClick={handleClose}>Close</Button>
                    <Button className='btnStyle' onClick={save}>Save</Button>
                </DialogActions> */}
            </Dialog>
        </div>
    );
};

export default MappingFieldsOverLay;
